import joi from 'joi'
import { ConsumerIdentityType } from '@mc-alberta/types'

const consumerIdentitySchema = joi
  .object({
    identityProvider: joi.string().valid('SRC'),
    identityType: joi
      .string()
      .required()
      .valid(ConsumerIdentityType.EMAIL_ADDRESS, ConsumerIdentityType.MOBILE_PHONE_NUMBER),
    identityValue: joi.string().required()
  })
  .options({ allowUnknown: true })

const schema = joi.object({
  srcDigitalCardId: joi.string().max(36),
  consumerIdentity: consumerIdentitySchema
})

export default schema
